
import { isEmpty, map } from 'es-toolkit/compat';
import { core } from '@tock/coretypes';

export function addPaymentIntent(
  purchaseOrder: core.PurchaseOrder,
  paymentIntentId?: string | null
): core.PurchaseOrder {
  if (!paymentIntentId) {
    return purchaseOrder;
  }

  const scaAction = { paymentIntentId };
  if (!isEmpty(purchaseOrder.paymentCards)) {
    purchaseOrder.paymentCards = map(purchaseOrder.paymentCards, (card) => ({
      ...card,
      scaAction,
    }));
  } else if (purchaseOrder.paymentCard) {
    purchaseOrder.paymentCard = { ...purchaseOrder.paymentCard, scaAction };
  }
  return purchaseOrder;
}

export function addPaymentIntentToPackage(
  packageOrder: core.PackagePurchaseOrder,
  paymentIntentId?: string
): core.PackagePurchaseOrder {
  if (!paymentIntentId) {
    return packageOrder;
  }

  packageOrder.purchaseOrder = map(packageOrder.purchaseOrder, (purchaseOrder) =>
    addPaymentIntent(purchaseOrder as core.PurchaseOrder, paymentIntentId)
  );
  return packageOrder;
}
